import { defineStore } from 'pinia'
import { accountService } from '@/services/accountService'
import errorService from '@/services/errorService';

export const useAccountStore = defineStore('account', {
  state: () => ({
    account: {},
    banks: {},
  }),

  actions: {
    async getAccount(id) {
      try {
        const response = await accountService.fetchAccount(id);
        this.account = response.data.data;
        this.banks = response.data.banks;

      } catch (error) {
        return errorService.handle(error);
      }
    },

    async updateAccount(params) {
      try {
        await accountService.updateAccount(params);
        return { success: true };
      }
      catch (error) {
        return errorService.handle(error);
      }
    },
  }
});